export const ORG_FILTER_DISPLAY_FLAG = Object.freeze({
  FIN_SOLD_TO: "FIN_SOLD_TO",
  FIN_FINCODE: "FIN_FINCODE",
  FIN_ENDUSER_FINCODE: "FIN_ENDUSER_FINCODE",
  FIN_SHIPPABILITY: "FIN_SHIPPABILITY",
  FIN_DEALER_REGION: "FIN_DEALER_REGION",
  FIN_DEALER_ZONE: "FIN_DEALER_ZONE",
  FIN_DEALER_DISTRICT: "FIN_DEALER_DISTRICT",
  FIN_COMPLETED_DATE: "FIN_COMPLETED_DATE",
  VIN_FEATURED_REFERENCES: "VIN_FEATURED_REFERENCES",
  ITSS_EXCEPTION: "ITSS_EXCEPTION",
  SPOT_BUY_AUTH: "SPOT_BUY_AUTH",
});
